import { createAction } from 'redux-actions';

export const startAddCandidateSubmit = createAction('START_ADD_CANDIDATE_SUBMIT');

export const resolveAddCandidateSubmit = createAction('RESOLVE_ADD_CANDIDATE_SUBMIT');

export const startAddCandidateByLinkSubmit = createAction('START_ADD_CANDIDATE_BY_LINK_SUBMIT');

export const resolveAddCandidateByLinkSubmit = createAction('RESOLVE_ADD_CANDIDATE_BY_LINK_SUBMIT');

export const getPendingCandidates = createAction('GET_PENDING_CANDIDATES');

export const setPendingCandidates = createAction('SET_PENDING_CANDIDATES');

export const getUserCandidates = createAction('GET_USER_CANDIDATES');

export const setUserCandidates = createAction('SET_USER_CANDIDATES');

export const getUserCandidate = createAction('GET_USER_CANDIDATE');

export const setUserCandidate = createAction('SET_USER_CANDIDATE');

export const updateCandidatePropById = createAction('UPDATE_CANDIDATE_PROP_BY_ID');

export const startApproveCandidateSubmit = createAction('START_APPROVE_CANDIDATE_SUBMIT');

export const resolveApproveCandidateSubmit = createAction('RESOLVE_APPROVE_CANDIDATE_SUBMIT');

export const rejectPendingCandidate = createAction('REJECT_PENDING_CANDIDATE');

export const downloadAttachedFile = createAction('DOWNLOAD_ATTACHED_FILE');
